/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'login';
const componentName = 'login-page';
const prefix = `${moduleName}.${componentName}`;

export const recoveryInstructionSent = `${prefix}.recoveryInstructionSent`;

export const ENGLISH = {
    [recoveryInstructionSent]: 'Recovery instruction sent to email',
};
